import { formatDate } from '../../helpers/dateHelpers';

import styles from './DateTimeCell.module.scss';

interface IDateTimeCellProps {
  date: Date | string;
}

function DateTimeCell({ date }: IDateTimeCellProps) {
  return (
    <>
      <div>{formatDate(date)}</div>
      <span className={styles.time}>{formatDate(date, 'HH:mm:ss')}</span>
    </>
  );
}

export default DateTimeCell;
